class CtxDropdownListController {
    constructor($scope, $attrs) {
        this.$scope = $scope;
        this.$attrs = $attrs;
    }

    $onInit() {
        this.$scope.$watch(() => this.value, (item) => {
            if(!this.list || !this.list.length || !item) return;
            this.list.forEach(li => { li.isSelected = li.text === item.text && li.value === item.value; });
        });
    }

    setValue(listItem) {
        this.value = listItem;
    }
}

CtxDropdownListController.$inject = ['$scope', '$attrs'];

class ctxDropdownList {
    constructor($timeout) {
        this.restrict = 'E';
        this.replace = true;
        this.template = require('./ctxDropdownList.template.html');
        this.controller = CtxDropdownListController;
        this.controllerAs = 'ctxDropdownListCtrl';
        this.require = ['^^ctxDropdown'];
        this.bindToController = {
            list: '<',
            value: '='
        };

        this.$timeout = $timeout;
    }

    link(scope, element, attrs, ctxDropdown) {
        this.$timeout(() => {

        }, 0);
    }

    static directiveFactory($timeout) {
        return new ctxDropdownList($timeout);
    }
}

ctxDropdownList.directiveFactory.$inject = ['$timeout'];

module.exports = ctxDropdownList.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxDropdown/ctxDropdownList.directive.js